'use client';

import CustomSelect, { ComboboxOption } from '@/components/custom-select';
import { useEmployeeInfoStore } from '@/hooks/use-employee-store';
import { EmployeeAuthInfo } from '@/server/api/v1/auth/types';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

const HeaderSelectStaff = () => {
    const transDef = useTranslations('System');

    const current = useEmployeeInfoStore((x) => x.current);
    const empInfos = useEmployeeInfoStore((x) => x.employeeInfos);
    const onChangeEmpInfo = useEmployeeInfoStore((x) => x.changeCurrentEmpInfo);

    const [isLoading, setIsLoading] = useState(true);
    const [empOptions, setEmpOptions] = useState<
        ComboboxOption<EmployeeAuthInfo>[]
    >([]);

    useEffect(() => {
        setIsLoading(true);
        if (empInfos.length) {
            setEmpOptions(
                empInfos.map((x) => ({
                    label: x.EmployeeFullName,
                    value: x.ID,
                    _origin: x,
                }))
            );
        }
        setIsLoading(false);
    }, [empInfos]);

    if (empOptions.length === 0 || isLoading) return <></>;
    if (empOptions.length === 1)
        return (
            <div className='hidden rounded-md bg-muted p-2 text-xs font-semibold text-muted-foreground md:block'>
                {empOptions[0].label}
            </div>
        );

    return (
        <div className='hidden md:block'>
            <CustomSelect.Single
                options={empOptions}
                placeholder={transDef('System_SelectEmployeeData')}
                value={current?.ID}
                className='h-8 w-40 text-xs lg:w-56 xl:w-64'
                itemForceMount
                onAfterValueChange={(_, opt) => {
                    if (!opt?._origin) return;
                    onChangeEmpInfo(opt?._origin as any);
                }}
                showCommand={empOptions.length > 5}
                popoverContentProps={{
                    align: 'end',
                    className: 'max-w-none w-96',
                }}
            />
        </div>
    );
};

export default HeaderSelectStaff;
